import React, { Component } from 'react'
import { Button, Modal, Table } from 'antd'
import _ from 'lodash'
import moment from 'moment'

import './ProjectSummaryModal.scss'

export default class ProjectSummaryModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalVisible: false,
        }

        this.handleClick = this.handleClick.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
    }

    handleClick() {
        const { onOpen } = this.props
        onOpen()

        this.setState({ modalVisible: true })
    }

    handleCancel() {
        this.setState({ modalVisible: false })
    }

    handleConfirm() {
        this.setState({ modalVisible: false })
    }

    render() {
        const { dataSource } = this.props
        const { modalVisible } = this.state
        const tableColumns = [{
            title: 'Date',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 150,
            render: (data, record) => moment(data).isSame(moment(), 'day') ? `Today ${moment(data).format('HH:mm')}` : moment(data).format('DD/MM/YYYY')
        }, {
            title: 'Document Name',
            dataIndex: 'target_name',
            key: 'target_name',
            width: 200
        }, {
            title: 'User Name',
            dataIndex: 'action_by',
            width: 100,
            key: 'action_by',
        }, {
            title: 'Action Content',
            dataIndex: 'action_content',
            key: 'action_content',
            render: (data, record) => _.startCase(data)
        }]

        return (
            <div className="ProjectSummaryModal-wrapper cheer-btn">
                <Button type="primary" onClick={this.handleClick}>Project Summary</Button>
                <Modal
                    width="60%"
                    wrapClassName="ProjectSummaryModal"
                    footer={null}
                    visible={modalVisible}
                    onCancel={this.handleCancel}
                >
                    <p className="info">Recent activity of this project will be shown below:</p>
                    <div className="content">
                        <Table
                            className="logs-table"
                            rowKey={'_id'}
                            columns={tableColumns}
                            dataSource={dataSource}
                            pagination={false}
                            scroll={{y: 250}}
                            size="small"
                        />
                    </div>
                    <div className="footer">
                        <Button type="primary" size="large" onClick={this.handleConfirm}>Done</Button>
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/ProjectSummaryModal/ProjectSummaryModal.js